import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useApi } from './ApiContext'; 
import toast from 'react-hot-toast'; // ➡️ TAMBAHAN: Guna toast abang

import './Login.css'; // Guna CSS login sepenuhnya

axios.defaults.withCredentials = true;

const ForgotPassword = () => {
  const { API_BASE_URL } = useApi();
  
  // ➡️ API Endpoints (Guna username sekarang)
  const REQUEST_OTP_API = `${API_BASE_URL}/forgot-password/request`;
  const VERIFY_OTP_API = `${API_BASE_URL}/forgot-password/verify`;

  // ➡️ States
  const [username, setUsername] = useState(''); // ⬅️ TUKAR: Guna username
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  
  const [maskedEmail, setMaskedEmail] = useState(''); // Untuk simpan emel yang dah ditapis (e.g. m***@mail.com)
  const [step, setStep] = useState(1); // Step 1: Username, Step 2: OTP & Password Baru
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  // ➡️ FASA 1: Hantar Username untuk minta OTP
  const handleRequestOtp = async (e) => {
    e.preventDefault();
    if (!username) return setError('Please enter your username');
    if (!API_BASE_URL) return setError('Configuration error. API URL is missing.');

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(REQUEST_OTP_API, { username });
      
      if (response.data.success) {
        // Ambil masked emel dari backend (contoh: m***h@gmail.com)
        const userEmail = response.data.maskedEmail || 'your registered email';
        setMaskedEmail(userEmail);
        
        // ➡️ PAPAR TOAST MACAM ABANG NAK
        toast.success(`OTP sent to ${userEmail}`, {
          duration: 5000,
          position: 'top-center',
        });

        setStep(2); // Tukar ke fasa masukkan OTP
      } else {
        setError(response.data.message || 'Failed to send OTP');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Username not found.');
    } finally {
      setLoading(false);
    }
  };

  // ➡️ FASA 2: Sahkan OTP & Tukar Password Baru (Hantar username sekali supaya backend kenal)
  const handleVerifyAndReset = async (e) => {
    e.preventDefault();
    if (!otp || !newPassword) return setError('Please fill in all fields');

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(VERIFY_OTP_API, { 
        username, // Sent sekali sebagai rujukan kunci di backend
        otp, 
        newPassword 
      });

      if (response.data.success) {
        toast.success('Password reset successful!');
        history.push('/login');
      } else {
        setError(response.data.message || 'Invalid OTP code');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="base-login">
      <div className="login-container">
        <h2>Forgot Password</h2>
        
        {error && <p className="error">{error}</p>}

        {/* ---------------- STEP 1: MINTA USERNAME ---------------- */}
        {step === 1 && (
          <form onSubmit={handleRequestOtp}>
            <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '15px', textAlign: 'center' }}>
              Enter your username to receive a 6-digit OTP code to your registered email.
            </p>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading}
                required
                placeholder="Enter your username"
              />
            </div>
            <button className="login-button" type="submit" disabled={loading}>
              {loading ? 'Checking...' : 'Send OTP Code'}
            </button>
          </form>
        )}

        {/* ---------------- STEP 2: MASUKKAN OTP & PASSWORD BARU ---------------- */}
        {step === 2 && (
          <form onSubmit={handleVerifyAndReset}>
            <p style={{ fontSize: '0.85rem', color: '#333', marginBottom: '15px', textAlign: 'center' }}>
              OTP has been sent to email for username: <strong>{username}</strong>
              <br />
              <span style={{ color: '#666', fontSize: '0.8rem' }}>({maskedEmail})</span>
            </p>

            <div className="form-group">
              <label htmlFor="otp">6-Digit OTP Code</label>
              <input
                type="text"
                id="otp"
                maxLength="6"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                disabled={loading}
                required
                placeholder="Enter 6-digit code"
                style={{ textAlign: 'center', letterSpacing: '4px', fontSize: '1.2rem' }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading}
                required
                placeholder="Enter new password"
              />
            </div>

            <button className="login-button" type="submit" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>

            <p className="auth-switch" style={{ marginTop: '15px', textAlign: 'center' }}>
              Wrong username? <span onClick={() => { setStep(1); setError(''); }}>Change Username</span>
            </p>
          </form>
        )}

        <p className="auth-switch" style={{ marginTop: '15px' }}>
          Remember your password?{' '}
          <span onClick={() => history.push('/login')}>Login Here</span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;